import React from 'react';
import { ECGPlot } from 'components';
import { ColorValueHex, ECGWaveFormResponseDto } from 'types/types';

import styles from './styles.module.sass';
import classNames from 'classnames';

type Props = {
  strokeColor?: ColorValueHex;
  titleClass?: string;
  assessmentClass?: string;
} & ECGWaveFormResponseDto;

export const ECGCaptureItem: React.FC<Props> = ({
  ecgLead,
  samples,
  sampleRate,
  strokeColor = '#00008B',
  titleClass,
  assessment,
  assessmentClass,
}) => {
  return (
    <>
      <h3 className={classNames(styles.lead, titleClass)}>{ecgLead}</h3>
      {assessment && (
        <div className={styles.assessment_container}>
          <h4 className={classNames(styles.title, assessmentClass)}>Assessment:</h4>
          <p className={classNames(styles.assessment, assessmentClass)}>{assessment}</p>
        </div>
      )}
      <div className={styles.plot}>
        <ECGPlot
          strokeColor={strokeColor}
          samples={samples}
          // drawChart={150}
          decreaseWave={40}
          // rate: 256 - good looking, 512 - real
          sampleRate={sampleRate}
          // duration to show 5 real, 9 - fit good
          // durationToShow={15}
          durationToShow={undefined}
          // volts 5 - good-looking, 0.5 - real
          // millivolts={2}
          millivolts={undefined}
          // time 7 good-looking, 10 - real
          startTime={0}
          showGrid={true}
          signalStrokeWidth={1}
          smallGridStrokeWidth={undefined}
          bigGridStrokeWidth={undefined}
          // real : 1
          physicalGridSquareSize={1}
          full={undefined}
          backgroundFill='#fff'
        />
      </div>
    </>
  );
};
